import { FunctionComponent } from 'react'

import { Path, Svg } from 'react-native-svg'
import { resize } from 'src/utils'

type Props = { size?: number }

export const AlertIcon43: FunctionComponent<Props> = ({ size = 24 }) => {
  const { height, width } = resize({ height: 24, size, width: 24 })

  return (
    <Svg {...{ viewBox: '0 0 24 24', width, height }}>
      <Path
        fill="#A84A76"
        d="M8.866 5.126a.5.5 0 1 1-.182.983 6.5 6.5 0 1 0 5.208 7.574 6.462 6.462 0 0 0-.004-2.361.5.5 0 1 1 .983-.182 7.45 7.45 0 0 1 .004 2.725 7.499 7.499 0 1 1-14.748-2.73 7.498 7.498 0 0 1 8.739-6.01ZM7.5 6.999a.5.5 0 0 1 .5.5v.927c.39.06.78.172 1.164.322.356.14.63.28.795.379a.5.5 0 0 1-.518.855A4.46 4.46 0 0 0 8.8 9.68c-.492-.192-.993-.306-1.465-.306-.985 0-1.68.476-1.68 1.1 0 .688.53 1.075 2.124 1.707l.152.06c1.9.752 2.602 1.25 2.602 2.415 0 1.292-.988 2.06-2.533 2.199v.9a.5.5 0 0 1-1 0l-.002-.896a4.504 4.504 0 0 1-1.606-.416c-.355-.17-.595-.35-.727-.487a.5.5 0 0 1 .72-.694c.053.055.198.164.44.28.433.209.977.336 1.647.336 1.36 0 2.06-.455 2.06-1.222 0-.556-.476-.894-1.97-1.485l-.152-.06c-1.984-.787-2.754-1.351-2.754-2.636 0-1.176 1.026-1.971 2.344-2.087V7.5a.5.5 0 0 1 .5-.5Zm11.18-5.68a4.5 4.5 0 1 1-6.363 6.363 4.5 4.5 0 0 1 6.364-6.363Zm-5.656.707a3.5 3.5 0 1 0 4.95 4.947 3.5 3.5 0 0 0-4.95-4.947Zm4.173.649.069.058a.5.5 0 0 1 0 .707l-1.06 1.06 1.06 1.06a.5.5 0 0 1 .058.639l-.058.069a.5.5 0 0 1-.707 0l-1.06-1.06-1.061 1.06a.5.5 0 0 1-.638.058l-.07-.058a.5.5 0 0 1 0-.707l1.062-1.06-1.061-1.061a.5.5 0 0 1-.058-.638l.058-.07a.5.5 0 0 1 .707 0l1.06 1.061 1.06-1.06a.5.5 0 0 1 .639-.058Z"
      />
    </Svg>
  )
}
